import { get, post, patch, del } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/people`;

export const list = (wsId, params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`${base(wsId)}${q}`);
};

export const getOne = (wsId, personId) => get(`${base(wsId)}/${personId}`);
export const create = (wsId, body) => post(base(wsId), body);
export const update = (wsId, personId, body) => patch(`${base(wsId)}/${personId}`, body);
export const remove = (wsId, personId) => del(`${base(wsId)}/${personId}`);
export const archive = (wsId, personId) => post(`${base(wsId)}/${personId}/archive`);

/* Notes on a person — backend uses GET /workspaces/:wsId/notes?personId= (no nested route) */
export const listNotes = (wsId, personId) => get(`/workspaces/${wsId}/notes?personId=${personId}`);

export const exportComplete = (wsId, body) => post(base(wsId) + '/export', body);
